'use client'

import { colors, Container, styled } from '@mui/material'

export const StyledIsi = styled(Container)(({ theme }) => ({
  position: 'relative',
	marginTop:0,
  h2: {
    marginBottom: theme.spacing(2),
    fontSize: '1.8rem',
  },
  '.isi p': {
    marginBottom: theme.spacing(1.5),
    '&.no-bot': {
      marginBottom: theme.spacing(0),
    },
  },
  '.body1': {
    fontSize: '.9rem',
  },

 
}))
